// extracted by mini-css-extract-plugin
export default {"ad":"index_ad_-u2tU","swiperItem":"index_swiperItem_lEfDO","adimg":"index_adimg_snINq"};